<template>
    <b-card no-body class="digitalstudies-card" @click="showDigitalStudies" >
        <b-card-img :src="imageSource" top class="digitalstudies-card-banner"></b-card-img>
        <b-card-body body-class="digitalstudies-card-body">
            <b-card-title>{{ title }}</b-card-title>
        </b-card-body>
    </b-card>
</template>

<script>
    export default {
        name: "design-2021-dashboard-digitalstudies-card-component",
        props: {
            title: {
                type: String,
                required: true,
            },
            imageSource: {
                type: String,
                default: '/images/digistudies/digitalstudies_dashboard_card_banner.png',
            },
            location: {
                type: String,
                default: '/exams'
            }
        },
        methods: {
            showDigitalStudies() {
                window.location.href = this.location.charAt(0) === '/' ? this.routes.baseUrl() + this.location : this.routes.baseUrl() + '/' + this.location;
            }
        }
    }
</script>

<style scoped lang="scss">
    .digitalstudies-card {
        height: 100%;
        position: relative;

         &:hover {
             cursor: pointer;
         }
    }

    .digitalstudies-card-banner {
        height: 128px;
        object-fit: cover;
    }

    .digitalstudies-card-body{
        padding-top: 15px;
        padding-bottom: 15px;

        .card-title {
            font-size: 1.3125rem;
            text-align: center;
            margin: 0;
        }
    }

</style>
